// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-node {
  position: relative;
  width: 100%;
  height: 100%;
}
.fs-node svg {
  width: 100% !important;
  height: 100% !important;
}
.fs-node svg path {
  stroke-width: 2px;
  vector-effect: non-scaling-stroke;
}
.fs-node:hover .nozzle-edge {
  display: block;
}
.fs-node .nozzle-edge:hover {
  height: 4px;
}
.fs-node .nozzle-edge {
  background-color: #037C4B;
  display: none;
  z-index: 1;
  height: 2px;
  cursor: pointer;
  position: absolute;
}
.fs-node .no-rotate {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform-origin: center;
}
.fs-node .fs-text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fs-node .fs-actuator,
.fs-node .fs-nozzle,
.fs-node .fs-tag,
.fs-node .fs-accessory {
  position: absolute;
  z-index: 0;
}
.fs-node .fs-accessory {
  z-index: 2;
}
.fs-node .fs-nodeSvg {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.fs-node .fs-tag {
  position: absolute;
  width: 100%;
}
.context-menu {
  position: fixed;
  left: 10px;
  top: 10px;
  border: 1px solid #d4d4d4;
  background-color: #fff;
}
.drawing-stream .x6-graph {
  cursor: crosshair;
}
.drawing-stream .x6-port-body:hover {
  stroke: #1677ff;
  stroke-width: 4px;
}
.hide-node-tool .x6-widget-transform-resize {
  display: none;
}
.node-readonly {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/styles.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;AAJA;EAMI,sBAAA;EACA,uBAAA;AACJ;AARA;EAUM,iBAAA;EACA,iCAAA;AACN;AAGE;EACE,cAAA;AADJ;AAfA;EAoBI,WAAA;AAFJ;AAlBA;EAwBI,yBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAHJ;AA1BA;EAiCI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AAJJ;AAlCA;EA0CI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAzCA;;;;EAqDI,kBAAA;EACA,UAAA;AANJ;AAhDA;EA0DI,UAAA;AAPJ;AAnDA;EA8DI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AARJ;AAzDA;EAqEI,kBAAA;EACA,WAAA;AATJ;AAaA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;AAXF;AAcA;EAEI,iBAAA;AAbJ;AAWA;EAKI,eAAA;EACA,iBAAA;AAbJ;AAoBA;EAEI,aAAA;AAnBJ;AAuBA;EACE,oBAAA;AArBF","sourcesContent":[".fs-node {\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  svg {\n    width: 100% !important;\n    height: 100% !important;\n\n    path {\n      stroke-width: 2px;\n      vector-effect: non-scaling-stroke;\n    }\n  }\n\n  &:hover .nozzle-edge {\n    display: block;\n  }\n\n  .nozzle-edge:hover {\n    height: 4px;\n  }\n\n  .nozzle-edge {\n    background-color: #037C4B;\n    display: none;\n    z-index: 1;\n    height: 2px;\n    cursor: pointer;\n    position: absolute;\n  }\n\n  .no-rotate {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform-origin: center;\n  }\n\n  .fs-text {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .fs-actuator,\n  .fs-nozzle,\n  .fs-tag,\n  .fs-accessory {\n    position: absolute;\n    z-index: 0;\n  }\n\n  .fs-accessory {\n    z-index: 2;\n  }\n\n  .fs-nodeSvg {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n  }\n\n  .fs-tag {\n    position: absolute;\n    width: 100%;\n  }\n}\n\n.context-menu {\n  position: fixed;\n  left: 10px;\n  top: 10px;\n  border: 1px solid #d4d4d4;\n  background-color: #fff;\n}\n\n.drawing-stream {\n  .x6-graph {\n    cursor: crosshair;\n  }\n  .x6-port-body:hover {\n    stroke: #1677ff;\n    stroke-width: 4px;\n  }\n  \n}\n\n\n\n.hide-node-tool {\n  .x6-widget-transform-resize {\n    display: none;\n  }\n}\n\n.node-readonly {\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
